<template>
  <div class="p-3 pt-5 rounded bg-body mb-5">
    <div class="row align-items-end mb-5">
      <div class="col-lg-6 mb-5 mb-lg-0">
        <date-field
          v-model="filters.fromDate"
          id="ticketsRealizationPie.fromDate"
          name="ticketsRealizationPie.fromDate"
          placeholder="Дата с"
        />
      </div>
      <div class="col-lg-6 mb-5 mb-lg-0">
        <date-field
          v-model="filters.toDate"
          id="ticketsRealizationPie.toDate"
          name="ticketsRealizationPie.toDate"
          placeholder="Дата по"
        />
      </div>
    </div>
    <div class="row align-items-end mb-5">
      <div class="col-lg-6">
        <button type="button" class="btn btn-sm w-100 mb-5 mb-lg-0 btn-primary" @click="applyFilters">
          Показать
        </button>
      </div>
      <div class="col-lg-6">
        <button type="button" class="btn btn-sm w-100 mb-5 mb-lg-0 btn-light-danger" @click="resetFilters">
          Сбросить
        </button>
      </div>
    </div>
    <loader v-if="loaded" :height="25" />
    <div v-show="!loaded">
      <apexchart
        type="pie"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import Loader from '@/components/Loader'
import DateField from '@/components/Fields/DateField'
import axios from 'axios'

export default {
  name: 'TicketsRealizationPie',
  components: {
    Loader,
    DateField,
    apexchart: VueApexCharts
  },
  data() {
    return {
      loaded: false,
      defaultFromDate: '',
      defaultToDate: '',
      filters: {
        fromDate: '',
        toDate: ''
      },
      series: [],
      chartOptions: {
        chart: {
          type: 'pie',
          width: 380
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { position: 'bottom' }
            }
          }
        ],
        legend: {
          position: 'bottom'
        },
        title: {
          text: 'Продажа абонемента',
          align: 'left'
        }
      }
    }
  },
  mounted() {
    this.setDefaultDates()
    this.getTicketsRealization()
  },
  methods: {
    toYmd(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    setDefaultDates() {
      // дефолт: ровно месяц (как было)
      const to = new Date()
      const from = new Date(to)
      from.setMonth(to.getMonth() - 1)

      this.defaultFromDate = this.toYmd(from)
      this.defaultToDate = this.toYmd(to)

      this.filters.fromDate = this.defaultFromDate
      this.filters.toDate = this.defaultToDate
    },
    normalizeRange(fromDateStr, toDateStr) {
      const fromStr = fromDateStr || this.defaultFromDate
      const toStr = toDateStr || this.defaultToDate

      const from = new Date(`${fromStr}T00:00:00`)
      const to = new Date(`${toStr}T00:00:00`)

      if (isNaN(from.getTime()) || isNaN(to.getTime())) {
        return { fromDate: fromStr, toDate: toStr }
      }

      if (from.getTime() <= to.getTime()) {
        return { fromDate: this.toYmd(from), toDate: this.toYmd(to) }
      }

      return { fromDate: this.toYmd(to), toDate: this.toYmd(from) }
    },
    applyFilters() {
      this.getTicketsRealization()
    },
    resetFilters() {
      this.filters.fromDate = this.defaultFromDate
      this.filters.toDate = this.defaultToDate
      this.getTicketsRealization()
    },
    getTicketsRealization() {
      this.loaded = true

      const { fromDate, toDate } = this.normalizeRange(
        this.filters.fromDate,
        this.filters.toDate
      )

      axios.get('order-service/api/v1/admin/statistic/tickets/charts/pie', {
        params: { fromDate, toDate }
      })
        .then(res => {
          const payload = res?.data && typeof res.data === 'object' ? res.data : {}
          const specs = Array.isArray(payload.specs) ? payload.specs : []
          const values = Array.isArray(payload.countSeries) ? payload.countSeries : []

          const labels = specs.map(s => s?.label || s?.id || '—')

          this.series = values
          this.chartOptions = {
            ...this.chartOptions,
            labels,
            title: {
              ...this.chartOptions.title,
              text: `Продажа абонемента по месяцам с ${fromDate} по ${toDate}`
            }
          }
        })
        .catch(err => {
          console.error('Ошибка при запросе getTicketsRealization:', err)
        })
        .finally(() => {
          this.loaded = false
        })
    }

  }
}
</script>
